export default __webpack_public_path__ + "static/media/loyola4.977dc9ca.jpg";